// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3IyKZ","productName":"Table_productName__2duJH"};